/* Sepet çekmecesi (telefonda alttan açılan sayfa), sayfa yenilenmeden güncellenir */
(function () {
if (window.DedeCartDrawer) return;
var D = document;

var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
var SECTION = 'cart-drawer';
var busy = false, queued = [], timers = {};
/* Paylaşılan sepet kilidi (tester.js/cart.js/cart-drawer.js): biri çalışırken
   diğeri istek atmasın. Kilit ilk erişende kurulur, yükleme sırası önemsiz. */
var LOCK = window.DedeCartLock = window.DedeCartLock || { busy: false, waiters: [] };
var holdsLock = false;
function lockFree() { if (!holdsLock) return; holdsLock = false; LOCK.busy = false; var w = LOCK.waiters.shift(); if (w) setTimeout(w, 0); }

function drawer() { return D.querySelector('[data-cart-drawer]'); }
function inner() { var d = drawer(); return d && d.querySelector('[data-cdr-inner]'); }
function lock(on) { D.documentElement.classList.toggle('cdr-lock', on); }

function announce(text) {
  var d = drawer(), live = d && d.querySelector('[data-cdr-live]');
  if (!live) return;
  live.textContent = '';
  setTimeout(function () { live.textContent = text; }, 50);
}
function showError(text) {
  var el = drawer() && drawer().querySelector('[data-cdr-error]');
  if (!el) return;
  el.textContent = text || '';
  el.hidden = !text;
}

function open() {
  var d = drawer();
  if (!d || d.open) return;
  if (typeof d.showModal === 'function') d.showModal();
  else d.setAttribute('open', '');
  lock(true);
  var close = d.querySelector('[data-cdr-close]');
  if (close) close.focus({ preventScroll: true });
}
function close() {
  var d = drawer();
  if (!d || !d.open) return;
  if (typeof d.close === 'function') d.close();
  else d.removeAttribute('open');
  lock(false);
}

/* içeriği sunucudan gelen HTML ile değiştir; odak aynı kontrole döner */
function render(html) {
  var cur = inner();
  if (!cur || !html) return;
  var doc = new DOMParser().parseFromString(html, 'text/html');
  var fresh = doc.querySelector('[data-cdr-inner]');
  if (!fresh) return;
  var ae = D.activeElement;
  var hadFocus = !!ae && cur.contains(ae);
  var focusSel = null;
  if (hadFocus) {
    var li = ae.closest('[data-key]'), key = li && li.getAttribute('data-key');
    if (key && ae.hasAttribute('data-cdr-step')) focusSel = '.cdr-item[data-key="' + key + '"] [data-cdr-step="' + ae.getAttribute('data-cdr-step') + '"]';
    else if (key && ae.matches('.cdr-qty__input')) focusSel = '.cdr-item[data-key="' + key + '"] .cdr-qty__input';
  }
  var scroll = cur.querySelector('.cdr__body');
  var top = scroll ? scroll.scrollTop : 0;
  cur.replaceWith(fresh);
  var nb = fresh.querySelector('.cdr__body');
  if (nb) nb.scrollTop = top;
  var count = parseInt(fresh.getAttribute('data-count'), 10) || 0;
  D.dispatchEvent(new CustomEvent('dede:cart:updated', { detail: { item_count: count } }));
  if (hadFocus && drawer().open) {
    var target = (focusSel && fresh.querySelector(focusSel)) || fresh.querySelector('[data-cdr-close]');
    target.focus({ preventScroll: true });
  }
}

function parse(r) {
  return r.text().then(function (t) {
    var j = null;
    try { j = JSON.parse(t); } catch (e) { j = null; }
    return { ok: r.ok, j: j };
  });
}

function refresh(openAfter) {
  return fetch(root + '?sections=' + SECTION, { credentials: 'same-origin' })
    .then(function (r) { return r.json(); })
    .then(function (j) {
      render(j[SECTION]);
      if (openAfter) open();
    })
    .catch(function () { if (openAfter) open(); });
}

function drain() { if (busy || LOCK.busy) return; if (!queued.length) return; var q = queued.shift(); post(q[0], q[1]); }

function post(url, body) {
  var d = drawer();
  if (!d) return;
  if (busy) { queued.push([url, body]); return; }
  if (LOCK.busy && !holdsLock) { queued.push([url, body]); LOCK.waiters.push(drain); return; }
  busy = true;
  if (!holdsLock) { holdsLock = true; LOCK.busy = true; }
  d.classList.add('is-updating');
  showError('');
  body.sections = [SECTION];
  body.sections_url = window.location.pathname;
  fetch(root + url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify(body)
  })
    .then(parse)
    .then(function (res) {
      if (res.ok && res.j && res.j.sections && res.j.sections[SECTION]) {
        render(res.j.sections[SECTION]);
        announce('Sepet güncellendi');
        return;
      }
      var msg = (res.j && (res.j.description || res.j.message)) || 'Sepet güncellenemedi. Lütfen tekrar deneyin.';
      return refresh(false).then(function () { showError(msg); announce(msg); });
    })
    .catch(function () {
      showError('Bağlantı hatası. Lütfen tekrar deneyin.');
    })
    .then(function () {
      busy = false;
      var dd = drawer();
      if (dd) dd.classList.remove('is-updating');
      /* kendi kuyruğu sürüyor: kilit elde kalsın */
      if (queued.length) { var q = queued.shift(); post(q[0], q[1]); return; }
      lockFree();
    });
}

function keyOf(el) {
  var li = el.closest('[data-key]');
  return li ? li.getAttribute('data-key') : '';
}
function schedule(input, delay) {
  var key = keyOf(input);
  if (!key) return;
  clearTimeout(timers[key]);
  timers[key] = setTimeout(function () {
    /* boş bırakılan kutu ürünü silmesin */
    if (input.value.trim() === '' || (input.validity && input.validity.badInput)) { input.value = input.defaultValue; return; }
    var qty = Math.max(0, parseInt(input.value, 10) || 0);
    if (String(qty) === input.defaultValue) return;
    post('cart/change.js', { id: key, quantity: qty });
  }, delay);
}

D.addEventListener('click', function (e) {
  var d = drawer();
  if (!d) return;

  var link = e.target.closest('[data-cart-link]');
  if (link) {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    e.preventDefault();
    open();
    refresh(false);
    return;
  }
  if (!d.contains(e.target)) return;

  /* arka plana tıklayınca kapat (basış da arka planda başlamalı) */
  if ((e.target === d && downOnBackdrop) || e.target.closest('[data-cdr-close]')) { close(); return; }

  var step = e.target.closest('[data-cdr-step]');
  if (step) {
    var input = step.parentElement.querySelector('input');
    if (!input) return;
    var max = parseInt(input.getAttribute('max'), 10);
    var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-cdr-step'), 10));
    if (max && next > max) next = max;
    input.value = next;
    schedule(input, 400);
    return;
  }
  var remove = e.target.closest('[data-cdr-remove]');
  if (remove) {
    e.preventDefault();
    post('cart/change.js', { id: keyOf(remove), quantity: 0 });
    return;
  }
  var add = e.target.closest('[data-cdr-add]');
  if (add) {
    add.disabled = true;
    post('cart/add.js', { items: [{ id: parseInt(add.getAttribute('data-cdr-add'), 10), quantity: 1 }] });
  }
});

var downOnBackdrop = false;
D.addEventListener('pointerdown', function (e) {
  var d = drawer();
  downOnBackdrop = !!d && e.target === d;
}, true);

D.addEventListener('change', function (e) {
  if (e.target.matches && e.target.matches('[data-cart-drawer] .cdr-qty__input')) schedule(e.target, 0);
});
D.addEventListener('keydown', function (e) {
  if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-cart-drawer] .cdr-qty__input')) {
    e.preventDefault();
    schedule(e.target, 0);
  }
});

/* Esc veya dialog kapanınca kilidi kaldır */
D.addEventListener('close', function (e) {
  if (e.target && e.target.matches && e.target.matches('[data-cart-drawer]')) lock(false);
}, true);

/* ürün sayfası formu: sayfadan ayrılmadan ekle */
D.addEventListener('submit', function (e) {
  var form = e.target;
  /* rp-card__form da yakalanır: öneri kartındaki "+" temadaki tek AJAX dışı
     eklemeydi, müşteriyi /cart'a atıyordu. Sınıf adı değiştirilmedi, çünkü
     set-builder.js 'form.pp__form'u "ana ürün formu" olarak arıyor. */
  if (!form.matches || !form.matches('form.pp__form, form.rp-card__form') || !window.FormData) return;
  e.preventDefault();
  var btn = form.querySelector('[data-add-button]'), err = form.querySelector('[data-add-error]');
  if (form._busy || (btn && btn.disabled)) return;
  form._busy = true;
  if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
  if (err) { err.hidden = true; err.textContent = ''; }
  function done() {
    form._busy = false;
    if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
  }
  fetch(root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    credentials: 'same-origin',
    body: new FormData(form)
  })
    .then(parse)
    .then(function (res) {
      done();
      if (!res.ok || !res.j) {
        if (err) { err.textContent = (res.j && (res.j.description || res.j.message)) || 'Ürün sepete eklenemedi.'; err.hidden = false; }
        return;
      }
      D.dispatchEvent(new CustomEvent('dede:cart:added', { detail: res.j }));
    }, function () {
      done();
      if (err) { err.textContent = 'Bağlantı hatası. Lütfen tekrar deneyin.'; err.hidden = false; }
    });
});

/* sepete eklenince güncelle ve aç (başka pencere açıksa sadece güncelle) */
D.addEventListener('dede:cart:added', function () {
  var otherModal = Array.prototype.some.call(D.querySelectorAll('dialog[open]'), function (x) { return !x.matches('[data-cart-drawer]'); });
  refresh(!otherModal);
});

/* geri tuşuyla dönülünce tazele, kilidi kaldır */
window.addEventListener('pageshow', function (e) {
  if (!e.persisted) return;
  var d = drawer();
  if (d && !d.open) lock(false);
  refresh(false);
});

/* telefonda üst çubuktan aşağı sürükleyince kapanır */
var dragY = null, dragP = null;
D.addEventListener('pointerdown', function (e) {
  var h = e.pointerType !== 'mouse' && e.target.closest && e.target.closest('.cdr__head');
  if (!h || e.target.closest('button') || innerWidth > 560) return;
  dragY = e.clientY; dragP = h.parentNode; dragP.style.transition = 'none';
});
D.addEventListener('pointermove', function (e) {
  if (dragY !== null) dragP.style.transform = 'translate3d(0,' + Math.max(0, e.clientY - dragY) + 'px,0)';
});
function endDrag(e) {
  if (dragY === null) return;
  var p = dragP, dy = e.type === 'pointerup' ? e.clientY - dragY : 0;
  dragY = null; p.style.transition = '';
  if (dy < 90) { p.style.transform = ''; return; }
  p.style.transform = 'translate3d(0,100%,0)';
  setTimeout(function () { close(); p.style.transform = ''; }, 260);
}
D.addEventListener('pointerup', endDrag);
D.addEventListener('pointercancel', endDrag);

window.DedeCartDrawer = { open: open, close: close, refresh: refresh };
})();
